module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "no-print botao botao_sem-preenchimento botao_medio botao_icone",
    attrs: {
      "type": "button",
      "id": "expandir"
    },
    on: {
      "click": _vm.expandirToggle
    }
  }, [_c('i', {
    staticClass: "fal fa-expand-arrows"
  }), _vm._v(" "), _c('i', {
    staticClass: "fal fa-compress-alt"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23816528"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ExpandirConteudo.vue
// module id = 1096
// module chunks = 1